export enum ComponentsType {
  vmConfiguration = 1,
  postProvisioning=2,
  policy=3,
}